'use client';

import { Logo } from '@petsmart-ui/sparky';

import { dataLayerPush, getBaseUrlJoined, layoutEvents } from '@libs/analytics';
import { NAVIGATION_URLS } from '@libs/core';

type LogoWrapperProps = {
    className?: string;
};

export const trackingData = (data: object) => Object.assign(data, { ...layoutEvents.headerClick });

export default function LogoWrapper({ className }: LogoWrapperProps) {
    return (
        <Logo
            data-testid="logo"
            title="Return to homepage"
            className={className}
            href={NAVIGATION_URLS.legacy.base}
            onClick={() =>
                dataLayerPush(
                    trackingData({
                        selection: 'logo',
                        link_url: getBaseUrlJoined(NAVIGATION_URLS.legacy.base),
                    })
                )
            }
        />
    );
}
